import { useMutation } from 'react-query';

import { UploadImageResponse } from '@/features/availability/types';
import { axios } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';
import { showNotification } from '@/utils/notificationUtils';
import { Pet } from '@/features/auth';

export type requestDTO = {
  data: {
    id?: number;
    name?: string;
    breed?: string;
    gender?: string;
    weight?: string;
    dateOfBirth?: string;
    notes?: string;
    petsImageUrl?: string;
    petType?: string;
    petColor?: string;
    petSize?:string;
    petAge?:string;
  };
};
type PetResponse = {
  petData: Pet
};
export type requestDTOUploadImage = {
  file: FormData;
  petsId?: string;
};

export const addPet = ({ data }: requestDTO): Promise<PetResponse> => {
  return axios.post(`parent/pets/add`, data);
};

export const addPetPicture = ({
  file,
  petsId,
}: requestDTOUploadImage): Promise<UploadImageResponse> => {
  return axios.post(
    petsId ? `parent/pets/${petsId}/upload-image` : 'parent/pets/upload-image',
    file
  );
};

type UseUpdateBusinessOptions = {
  config?: MutationConfig<typeof addPet>;
};

type UseUpdateBusinessOptions1 = {
  config?: MutationConfig<typeof addPetPicture>;
};

export const useAddPet = ({ config }: UseUpdateBusinessOptions = {}) => {
  return useMutation({
    onSuccess: () => {
      showNotification({
        type: 'success',
        title: 'Pet details updated successfully',
      });
    },
    ...config,
    mutationFn: addPet,
  });
};

export const useUploadPicture = ({ config }: UseUpdateBusinessOptions1 = {}) => {
  return useMutation({
    onSuccess: () => {
      showNotification({
        type: 'success',
        title: 'Pet picture uploaded successfully',
      });
    },
    ...config,
    mutationFn: addPetPicture,
  });
};
